export * from '@fhs/routing/src/routes/[staticPage]/_layout';
export { default } from '@fhs/routing/src/routes/[staticPage]/_layout';
